import { createSlice } from '@reduxjs/toolkit';
import { DashboardStats, Nullable } from '../../types';
import { ReducerState } from '../configure-store';
import { getDashboardStats } from '../thunks/dashboard-thunks';
import { takeOne } from '../../helpers/store';

export interface DashboardState extends ReducerState {
    stats: Nullable<DashboardStats>;
}

const initialState: DashboardState = {
    error: '',
    loading: 'none',
    requestIds: [],
    stats: null,
};

const slice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        resetDashboardStats: (state: DashboardState) => {
            state.stats = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDashboardStats.pending, takeOne.pendingActionCase)
            .addCase(getDashboardStats.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.stats = action.payload;
            })
            .addCase(getDashboardStats.rejected, takeOne.rejectedActionCase);
    },
});

export const { resetDashboardStats } = slice.actions;

export default slice.reducer;
